import React from 'react'

interface QRCodeComponentProps {
  src: string
  alt?: string
  largeMaxHeight?: boolean
}

const QRCodeComponent = React.forwardRef<HTMLImageElement, QRCodeComponentProps>(({ src, alt, largeMaxHeight }, ref) => {
  return <img ref={ref} src={src} className={`rf-h-full ${largeMaxHeight ? 'rf-max-h-qrcodelarge' : 'rf-max-h-qrcode'}`} alt={alt || 'QR Code'} />
})

export default QRCodeComponent
